<template>
    <form novalidate
          data-testid="option-sets-form"
          class="option-sets form-v form--shade">
        <OptionSet v-for="optionSet in optionSets"
                   :key="optionSet.ID"
                   v-model="selections[optionSet.ID]"
                   :option-set="optionSet" />
    </form>
</template>

<script>
import OptionSet from '@/epos/vue/modals/CartLineDetails/OptionSet';

/**
 * @typedef {object} OptionSetSelections
 * @property {OptionSet} optionSet
 * @property {ItemOption[]} options
 */

export default {
    components: { OptionSet },

    props: {
        optionSets: {
            type: Array,
            required: true,
        },

        modelValue: {
            type: Object,
            default: () => ({}),
        },
    },

    emits: ['update:modelValue'],

    data() {
        return {
            selections: {
                ...this.modelValue,
            },
        };
    },

    watch: {
        selections: {
            handler() {
                // Emit the updated selections whenever they change
                this.change();
            },
            deep: true,
        },
    },

    created() {
        // Initialize selections with empty arrays for each option set.s
        this.optionSets.forEach((optionSet) => {
            if (!this.selections[optionSet.ID]) {
                this.selections[optionSet.ID] = [];
            }
        });
    },

    methods: {
        change() {
            this.$emit('update:modelValue', this.selections);
        },
    },
};
</script>
